import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');


/*
SELECT  *  FROM WPT_PERSON WHERE IMG_REF='H2624'
*/	



const RenderWpForm = () => {

const aftertriggerselect = (name, value) => {
	console.log('aftertriggerselect: '+name);
	return '';
	
}

const resturl=sessionStorage.getItem("RESTURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const navVsaform = React.useRef();
//const [linkvsaform, setLinkvsaform] = useState({VSA_APP_ID:0});
//setLinkvsaform(VSA_APP_ID:vsaapp.VSA_APP_ID);
const [vsaapp, setVsaapp] = useState({REF_NUM:null, VSA_APP_ID:null});
const [selectedFiles, setSelectedFiles] = useState([]);

const [visibformfields, setVisibformfields] = useState({
	applicantname:false
	,applicantfoto:false
	});


const [applicant, setApplicant] = useState({
IMG_REF:''
, applicantsurname:''
, applicantnames:''
, FOTO_SIZE:0});

const [belonger, setBelonger] = useState({
	belongersurname:''
	,belongernames:''
	,OWNER:''
	});

const [dowait, setDowait] = useState({show: false});
const [progress, setProgress] = useState({
perct:null
});


const location = useLocation();


useEffect(() => {
	
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if	
	
document.title =   "APS New Application";	
if (document.getElementById('cbbelongerdone'))
	document.getElementById('cbbelongerdone').disabled=true;

 },[]);


useEffect(() => {
console.log("selectedFiles.length: "+selectedFiles.length);
 },[JSON.stringify(selectedFiles)]);


useEffect(() => {
	
	if (visibformfields.applicantname==true){
		const applicantnamesOk=(""+applicant.applicantsurname).length>1 && (""+applicant.applicantnames).length>1;
		console.log('applicantnamesOk: '+applicantnamesOk);
		if (document.getElementById('fotofile'))
			document.getElementById('fotofile').style.visibility=applicantnamesOk?'visible':'hidden';
		}//end if
		
	
 },[visibformfields]);


useEffect(() => {
/*
when user upload foto get refnum first
after refnum is set then upload foto
*/
	if (vsaapp.REF_NUM!=null)
		uploadapplicantfoto();

	if (vsaapp.VSA_APP_ID!=null)
		navVsaform.current?.click();
	
 },[vsaapp]);




useEffect(() => {
	//console.log('applicant: '+JSON.stringify(applicant));
	//console.log('belonger.belongersurname: '+belonger.belongersurname);
	
		const belongernamesOk=(""+belonger.belongersurname).length>1 && (""+belonger.belongernames).length>1;
		//console.log('belongernamesOk: '+(""+belonger.names).length);
		if (document.getElementById('cbbelongerdone'))
			document.getElementById('cbbelongerdone').disabled=!belongernamesOk;
	
		

 },[belonger]);

useEffect(() => {


	console.log('applicant.applicant: '+applicant.applicantsurname);
	
	const applicantnamesOk=(""+applicant.applicantsurname).length>1 && (""+applicant.applicantnames).length>1;
	console.log('applicantnamesOk: '+applicantnamesOk);
	if (document.getElementById('fotofile'))
		document.getElementById('fotofile').style.visibility=applicantnamesOk?'visible':'hidden';

	
 },[applicant]);



function selectedFilesChange(event, p_Filename){
//console.log('selectedFilesChange index: '+index);

if (event.target.files.length>1){
	showsnackbar("upload only one file please");
	return;
	}
else if (event.target.files.length==0)
	return;
	
const fileName=event.target.files[0].name;
var fileExtension = "";
if (fileName.lastIndexOf(".") > 0) 
	fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);
//,.jpg,.jpeg
const lsExtension="png, jpg, jpeg, bmp, webp, gif";
if (!(", "+lsExtension).includes(", "+fileExtension)){
	document.getElementById("fotofile").value='';
	showsnackbar("error: the uploaded file must have one of these extensions: "+lsExtension);
	return;
	}//end if	

document.getElementsByName('applicantsurname')[0].readOnly=true;
if (!document.getElementsByName('applicantsurname')[0].classList.contains("gnsbro"))
	document.getElementsByName('applicantsurname')[0].classList.add("gnsbro");

document.getElementsByName('applicantnames')[0].readOnly=true;
if (!document.getElementsByName('applicantnames')[0].classList.contains("gnsbro"))
	document.getElementsByName('applicantnames')[0].classList.add("gnsbro");


let temp=selectedFiles;
const i=0;//selectedFiles.length
//console.log('selectedFiles.length: '+i);
temp[i]={file:event.target.files[0], name:p_Filename, ext:fileExtension};
setSelectedFiles((prev)=>{
	return [...temp]/*return [...prev, ...temp]*/
});

}//end func



function handleApplicantChange(e){

const elemName=e.target.name;

const strvalue = (""+e.target.value).trim();

setApplicant((prev)=>{
return {...prev, [elemName]:strvalue}
});

}//end func
function handleBelongerChange(e){

const elemName=e.target.name;

const strvalue = (""+e.target.value).trim();

setBelonger((prev)=>{
return {...prev, [elemName]:strvalue}
});

	//console.log('handleBelongerChange strbelonger.length: '+strbelonger.length);
/*
	if (strbelonger.length<3){
		($( "#belonger" )).autocomplete({source: []});
		if (document.getElementById('cbbelongerdone'))
			document.getElementById('cbbelongerdone').disabled=true;
		return;
		}	

afterhandleBelongerChange();
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {applicant_OR_belonger:"belongername", crit:strbelonger} )
  };		

  fetch(resturl+'rarwpform/handleBelongerChange',requestOptions)
      .then(res => res.json())
      .then(res => 	afterhandleBelongerChange(res) )
      .catch(err => console.log(err));
*/

}//end func


function afterhandleBelongerChange(){

/*
if (document.getElementById('cbbelongerdone'))
	document.getElementById('cbbelongerdone').disabled=false;
let arrCmp=[];
	
res.map((col, index) => {
			arrCmp.push(col['belonger']);
		});
	
	//console.log('arrCmp.length: '+arrTPT_INF.length);
	
    ($( "#belonger" )).autocomplete({source: arrCmp});   
  
  $('#belonger').autocomplete('search', '');
  document.getElementsByName('belonger')[0].focus();
*/
	
	
}//end func	



function getrefnum(){
	
	console.log("selectedFiles.length: "+selectedFiles.length);
	
	if (selectedFiles.length<1){
		showsnackbar("please select a file first");
		return;
		}//
		
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME")} )
  };		
	
	setDowait({show:true});
	
  fetch(resturl+'rarwpform/getrefnum',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetrefnum(res) )
      .catch(err => console.log(err));
}//end func


function aftergetrefnum(res){
	setVsaapp((prev)=>{
		return {...prev, REF_NUM:res[0].REF_NUM}		
	});
}//end func

function createvsaapp(){
	
	const params={
		applicant:applicant
		, belonger:belonger
		, username:sessionStorage.getItem("USERNAME")
		, REF_NUM:vsaapp.REF_NUM
		};
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDowait({show:true});

  fetch(resturl+'rarvsaform/createvsaapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftercreatevsaapp(res) )
      .catch(err => console.log(err));
}//end func

function aftercreatevsaapp(res){
	
setDowait({show:false});

setVsaapp((prev)=>{
	return {...prev, VSA_APP_ID:res[0].VSA_APP_ID}		
});


}//end func




function navigvsaapp(){
}//end func



function clickNoimgref(e){
if (e.target.checked){
	document.getElementById('IMG_REF').value='';
	document.getElementById('IMG_REF').readOnly=true;
	document.getElementById('IMG_REF').classList.add("gnsbro");
	}
else{
	document.getElementById('IMG_REF').readOnly=false;
	document.getElementById('IMG_REF').classList.remove("gnsbro");
	}	
}//end func

function clickCbbelongerdone(e){


setVisibformfields((prev)=>{
	return {...prev, applicantname:e.target.checked}		
});
	
document.getElementById('cbbelongerdone').disabled=true;
	
if (e.target.checked){
	document.getElementById('belongersurname').readOnly=true;
	document.getElementById('belongersurname').classList.add("gnsbro");
	document.getElementById('belongernames').readOnly=true;
	document.getElementById('belongernames').classList.add("gnsbro");

	if (document.getElementsByName('applicantsurname')[0])
		document.getElementsByName('applicantsurname')[0].focus();

/*
	setBelonger((prev)=>{
		const belonger = document.getElementById('belonger').value;
		return {...prev, belonger:belonger}
	});
*/
	}
else{
	document.getElementById('belongersurname').readOnly=false;
	document.getElementById('belongersurname').classList.remove("gnsbro");
	document.getElementById('belongernames').readOnly=false;
	document.getElementById('belongernames').classList.remove("gnsbro");
	}

}//end func


async function uploadapplicantfoto(){
	console.log('uploadapplicantfoto: '+selectedFiles.length);
	
//setAxiofl({ selectedFile: event.target.files });	
	//event.target.files
/*
ensure the below line in node js has the correct array size of 1 
router.post('/uploadfiles', upload.array('filesupload',1), (req, res, next) => {
*/	
 
 const FormData = require('form-data'); // npm install --save form-data

const form = new FormData();

form.append('REF_NUM', vsaapp.REF_NUM);
form.append('USERNAME', sessionStorage.getItem("USERNAME"));
//let formfiles={foto:false,sign:false,scans:false};
//let filenames={foto:'', ext:''};
let fotoFile=null;
let numfilesupload=0;
for (var i=0; i<selectedFiles.length; i++){
	
	const currfile=selectedFiles[i].file;
	
	if (selectedFiles[i].name=='foto.png'){

		const newFileName='foto.'+selectedFiles[i].ext;
		fotoFile=new File([currfile], newFileName);
		
		form.append('FOTO_EXT', selectedFiles[i].ext);
		console.log("ext: "+selectedFiles[i].ext);
		numfilesupload++;
		//formfiles.foto=true;
		}//end if
	
	}//end for


if (fotoFile!=null)	{
	form.append('filesupload', fotoFile);
	const request_config = {
		onUploadProgress: data => {
		  //Set the progress value to show the progress bard
		  setProgress({perct:Math.round((100 * data.loaded) / data.total)});
		},
	};
	//setDowait({show:true});
	console.log("to call uploadapplicantfoto!");
	await axios.post(resturl+'rarvsaform/uploadapplicantfoto', form, request_config)
	.then(res => afteruploadapplicantfoto(res.data));
	
	}


{/*
	function cb(res){
		console.log('cb: '+JSON.stringify(cb));
	}

*/}

	
}//end func

function afteruploadapplicantfoto(data){
	console.log('afteruploadapplicantfoto: '+JSON.stringify(data));

/*
	if (document.getElementById('btnsubmitapp'))
		document.getElementById('btnsubmitapp').style.visibility='visible';
	
*/

	//showsnackbar('record update complete');
	setDowait({show:false});
	
	if (data.fotoOk==true)
		setApplicant((prev)=>{
			return {...prev, FOTO_SIZE:data.filesize}
		});
	else
		alert("The photograph of the applicant did not meet the requirement; please verify the file format and width and height should be close to 600 pixels");
		

}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function nofunc(e){
}//end func

	
  return (
    <>

<fieldset className='fieldsetlg' style={{width:"75%",marginTop:"30px"}} >
<legend>Turks & Caicos Visa Application {vsaapp.REF_NUM}</legend>





<table border="0" align='center' style={{marginTop:"10px", marginBottom:"10px"}} >	
<tbody>
	<tr>
		<td align='right' >enter surety's Family/Last/Surname:</td>
		<td align='left' ><input name='belongersurname' id='belongersurname' size='38' defaultValue={belonger.belongersurname} onChange={(e)=>{handleBelongerChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder="enter surety's Family/Last/Surname" /></td>
	</tr>
	<tr>
		<td align='right' >enter surety's Given/First/Christian names:</td>
		<td align='left' ><input name='belongernames' id='belongernames' size='38' defaultValue={belonger.belongernames} onChange={(e)=>{handleBelongerChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder="enter surety's Given/First/Christian names" /></td>
	</tr>
	<tr>
		<td align='center' colSpan="2" >
		<input type='checkbox' id='cbbelongerdone' onClick={(e)=>{clickCbbelongerdone(e);}}  /><label htmlFor='cbbelongerdone' className="hand" >done entering surety's name</label>
		</td>
	</tr>
	{
	visibformfields.applicantname==true &&
	<>
	<tr>
		<td align='right' >enter applicant's Family/Last/Surname:</td>
		<td align='left' ><input name='applicantsurname' size='38' defaultValue={applicant.applicantsurname}  onChange={(e)=>{handleApplicantChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder="enter applicant's Family/Last/Surname" /></td>
	</tr>
	<tr>
		<td align='right' >enter applicant's Given/First/Christian names:</td>
		<td align='left' ><input name='applicantnames' size='38' defaultValue={applicant.applicantnames} onChange={(e)=>{handleApplicantChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder="enter applicant's Given/First/Christian names" /></td>
	</tr>
	
		{
		applicant.FOTO_SIZE==0 && 
		<>
		<tr>
		<td align='right' >please upload a foto of applicant's face.<br/>
		accepted file formats: png, jpg, jpeg, bmp, webp, gif
		</td>
		<td align='left' ><input type='file' id='fotofile' accept=".png,.jpg,.jpeg,.bmp,.webp,.gif" onChange={(e)=>{selectedFilesChange(e, 'foto.png');}}  /></td>
		</tr>
			{
			selectedFiles.length>0 &&
			<tr>
			<td align='right' >&nbsp;</td>
			<td align='left' >
			{!dowait.show && <button className="button" onClick={(e)=>{getrefnum();}} >{"upload foto of applicant's face"}</button>}
			{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			</td>
			</tr>
			}
		</>
		}
	
		{
		applicant.FOTO_SIZE>0 &&
		<>
		<tr>
			<td align='right' >&nbsp;</td>
			<td align='left' >
			<img src={resturl+"rarwpform/getwptappfoto?path="+vsaapp.REF_NUM+"/foto.png"} border='0' height="150" />
			</td>
		</tr>
		<tr>
			<td align='right' >&nbsp;</td>
			<td align='left' >
			{!dowait.show && <button className="button" onClick={(e)=>{createvsaapp();}}  >proceed to application form</button>}
			</td>
		</tr>
		</>
		}

	</>
	}	
</tbody>
</table>




	
</fieldset>

          <NavLink ref={navVsaform} to={"/vsaform"} style={{display:"none"}} state={{VSA_APP_ID:vsaapp.VSA_APP_ID}} >
		click here to wpform
        </NavLink>

<div id="snackbar">&nbsp;</div>

    </>
  );
  


};


export default RenderWpForm;